import { Toast, useRect } from '@statsbomb/kitbag-components';
import {
  _IgnoreAlignmentCheckProvider,
  Playlist,
  usePlaylist,
  usePlaylistCurrentlySelected,
  VideoEvent,
} from '@statsbomb/video-client-js';
import { useAtom, useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { messageOffsetAlignmentVerificationAtom } from '../../atoms/messages';
import { videosRequiringAlignmentVerificationAtom } from '../../atoms/offsetAlignment';
import useAlignmentStatus from '../../hooks/offsetAlignmentStatus';
import {
  BREAKPOINT as ALIGNMENT_VERIFICATION_BREAKPOINT,
  PlayerAndPlaylist,
  PlaylistContainer,
  VideoContainer,
} from './AlignmentVerification.styles';
import AlignmentVerificationSelection from './AlignmentVerificationSelection';

export function AlignmentVerification({ onBack }) {
  const intl = useIntl();

  const videosRequiringAlignmentVerification = useAtomValue(
    videosRequiringAlignmentVerificationAtom,
  );
  const [message, setMessage] = useAtom(messageOffsetAlignmentVerificationAtom);

  const playlist = usePlaylist();
  const [currentlySelected] = usePlaylistCurrentlySelected();
  const { calculateAlignmentStatus } = useAlignmentStatus();

  const [elementRef, { width }] = useRect();

  const hasColumnLayout = width >= ALIGNMENT_VERIFICATION_BREAKPOINT;

  const onClose = () => {
    setMessage(null);
  };

  return (
    <PlayerAndPlaylist $hasColumnLayout={hasColumnLayout} ref={elementRef}>
      <PlaylistContainer $hasColumnLayout={hasColumnLayout}>
        <Playlist
          onBack={onBack}
          title={intl.formatMessage({
            defaultMessage: 'Video Alignment Confirmation',
            id: '5f002',
          })}
        />
      </PlaylistContainer>
      <VideoContainer $hasColumnLayout={hasColumnLayout}>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <_IgnoreAlignmentCheckProvider>
          <VideoEvent
            events={videosRequiringAlignmentVerification?.map((event) => ({
              descriptionLineThree: calculateAlignmentStatus(
                event,
                playlist.find((playlistEntry) => playlistEntry.id === event.id),
              ),
              id: event.id,
              selectedEntry: event.id === currentlySelected?.id,
            }))}
          />
        </_IgnoreAlignmentCheckProvider>
        <AlignmentVerificationSelection />
        {message && (
          <Toast
            isOpen={!!message.text}
            onClose={onClose}
            type={message.type || 'info'}
          >
            {message.text}
          </Toast>
        )}
      </VideoContainer>
    </PlayerAndPlaylist>
  );
}

AlignmentVerification.propTypes = { onBack: PropTypes.func };
AlignmentVerification.defaultProps = { onBack: undefined };

export default { AlignmentVerification };
